<script lang="ts">
  import { page } from "$app/state";
  import { m } from "#messages";
  import { BASE_LOCALE, LOCALES, basePath } from "#lib/locale.ts";
  import type { Locale } from "#lib/locale.ts";
  import { OG_IMAGE, PUBLIC_PATHS, localizedPath } from "./site.ts";

  let {
    title,
    description,
    locales = LOCALES,
  }: { title: string; description: string; locales?: readonly Locale[] } = $props();

  const fullTitle = $derived(m.meta_title({ page: title, app: m.app_name() }));
  const canonical = $derived(new URL(page.url.pathname, page.url.origin).href);
  const image = $derived(new URL(OG_IMAGE.path, page.url.origin).href);

  const alternates = $derived.by(() => {
    const path = basePath(page.url.pathname);
    if (!PUBLIC_PATHS.includes(path)) return [];
    const href = (locale: Locale): string =>
      new URL(localizedPath(path, locale, BASE_LOCALE), page.url.origin).href;
    return [
      ...locales.map((locale) => ({ hreflang: locale, href: href(locale) })),
      { hreflang: "x-default", href: href(BASE_LOCALE) },
    ];
  });
</script>

<svelte:head>
  <title>{fullTitle}</title>
  <meta name="description" content={description} />
  <link rel="canonical" href={canonical} />
  {#each alternates as alternate (alternate.hreflang)}
    <link rel="alternate" hreflang={alternate.hreflang} href={alternate.href} />
  {/each}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content={m.app_name()} />
  <meta property="og:title" content={fullTitle} />
  <meta property="og:description" content={description} />
  <meta property="og:url" content={canonical} />
  <meta property="og:image" content={image} />
  <meta property="og:image:width" content={String(OG_IMAGE.width)} />
  <meta property="og:image:height" content={String(OG_IMAGE.height)} />
  <meta property="og:image:alt" content={m.meta_image_alt()} />
  <meta name="twitter:card" content="summary_large_image" />
</svelte:head>
